/* eslint-disable no-const-assign */
// material
import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  TableContainer,
  Box,
  Collapse,
  IconButton,
  Switch,
  Typography
} from '@material-ui/core';
// eslint-disable-next-line import/no-unresolved
import Scrollbar from 'src/components/Scrollbar';
// components
//

// ----------------------------------------------------------------------

import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import React, { useEffect, useState } from 'react';
import arrowIosUpwardFill from '@iconify/icons-eva/arrow-ios-upward-fill';
import editIcon from '@iconify/icons-eva/edit-fill';
import deleteIcon from '@iconify/icons-ic/round-delete-outline';
import arrowIosDownwardFill from '@iconify/icons-eva/arrow-ios-downward-fill';
// eslint-disable-next-line import/no-unresolved
import addRule from '@iconify/icons-eva/plus-circle-outline';
import { useDispatch, useSelector } from 'react-redux';
// eslint-disable-next-line import/no-unresolved
import {
  deleteCampaignRule,
  getCampaignRuleData,
  resetError,
  resetSuccess
  // eslint-disable-next-line import/no-unresolved
} from 'src/redux/slices/campaignrules';
import { useSnackbar } from 'notistack5';
import Label from '../../Label';
import CampaignRuleForm from './CampaignRuleForm';
import CampaignRuleDialog from './CampaignRuleDialog';
import CampaignRuleParentForm from './CampaignRuleParentForm';

// ----------------------------------------------------------------------

CollapsableTableRow.propTypes = {
  row: PropTypes.shape({
    date_added: PropTypes.string.isRequired,
    id: PropTypes.number,
    rules: PropTypes.array.isRequired,
    active: PropTypes.bool,
    campaign_rule_name: PropTypes.string.isRequired
  }).isRequired,
  collapsableTableHead: PropTypes.array
};

export function CollapsableTableRow({ row, collapsableTableHead }) {
  let indexNumber = 0;
  const dispatch = useDispatch();

  const handleRuleDelete = (e, id) => {
    dispatch(deleteCampaignRule(id));
  };
  const [open, setOpen] = useState(false);

  return (
    <>
      <TableRow key={row.id}>
        <TableCell>
          <IconButton size="small" onClick={() => setOpen(!open)}>
            <Icon icon={open ? arrowIosUpwardFill : arrowIosDownwardFill} />
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.campaign_rule_name}
        </TableCell>
        <TableCell align="center">{row.rules.length}</TableCell>
        <TableCell align="center">{row.date_added}</TableCell>
        <TableCell align="center">
          {/* <Switch checked={row.active} /> */}
          <Label title={row.active ? 'Active' : 'In-Active'} color={row.active ? 'success' : 'warning'}>
            {row.active ? 'Active' : 'In-Active'}
          </Label>
        </TableCell>
        <TableCell align="center" title="Edit">
          <CampaignRuleDialog
            dialogTitle="Edit Campaign Rule Set"
            ComponentCalled={CampaignRuleParentForm}
            // icon={editIcon}
            showbtnIcon
            // parentRuleId={row.id}
            editId={{ parentRuleId: row.id, name: row.campaign_rule_name, status: row.active }}
          />
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6} sx={{ background: 'blanchedalmond' }}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box>
              <Table
                size="small"
                aria-label="purchases"
                sx={{
                  margin: 1
                }}
              >
                {row.rules.length !== 0 ? (
                  <>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          align="center"
                          colSpan={collapsableTableHead.length}
                          sx={{
                            background: 'blanchedalmond',
                            boxShadow: 'inset -8px 0 0 blanchedalmond !important;',
                            fontSize: '16px'
                          }}
                        >
                          Rule List
                        </TableCell>
                        {/* <TableCell
                          align="right"
                          sx={{ background: 'blanchedalmond', boxShadow: 'inset -8px 0 0 blanchedalmond !important;' }}
                          title="Add Rule"
                        > */}
                        {/* {open && (
                            <CampaignRuleDialog
                              dialogTitle="Add Campaign Rule"
                              ComponentCalled={CampaignRuleForm}
                              icon={addRule}
                              parentRuleId={row.id}
                            />
                          )} */}
                        {/* </TableCell> */}
                      </TableRow>
                      {/* Collapsable Table Head Row */}
                      <TableRow>
                        {collapsableTableHead.map((headData) => (
                          <TableCell
                            sx={{
                              boxShadow: headData.id === 'no' || headData.id === 'action' ? 'none !important' : ''
                            }}
                            align={headData.align ? headData.align : 'center'}
                            key={headData.key}
                          >
                            {headData.label}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody sx={{ background: 'white' }}>
                      {row?.rules.map((nestedRowData, index) => (
                        <>
                          {index !== 0 && nestedRowData && (
                            <TableRow key={nestedRowData.id + 1}>
                              <TableCell
                                component="th"
                                scope="row"
                                align="center"
                                colSpan="5"
                                sx={{ fontWeight: 'bolder' }}
                              >
                                AND
                              </TableCell>
                            </TableRow>
                          )}
                          {nestedRowData?.rules.map((innerNestedRules, index) => {
                            indexNumber += 1;
                            return (
                              <>
                                {index !== 0 && (
                                  <TableRow key={nestedRowData.id} sx={{ background: 'aliceblue' }}>
                                    <TableCell
                                      component="th"
                                      scope="row"
                                      align="center"
                                      colSpan="5"
                                      sx={{ fontWeight: 'bolder' }}
                                    >
                                      OR
                                    </TableCell>
                                  </TableRow>
                                )}
                                <TableRow key={innerNestedRules.id} sx={{ background: 'aliceblue' }}>
                                  <TableCell>{indexNumber}</TableCell>
                                  <TableCell>{innerNestedRules.column_name}</TableCell>
                                  <TableCell align="center">{innerNestedRules.if_cell_value}</TableCell>
                                  <TableCell align="center">{innerNestedRules.value_or_text}</TableCell>
                                  <TableCell align="center">
                                    {index === 0 && (
                                      <>
                                        <CampaignRuleDialog
                                          dialogTitle="Edit Campaign Rule"
                                          ComponentCalled={CampaignRuleForm}
                                          icon={editIcon}
                                          showbtnIcon
                                          parentRuleId={row.id}
                                          editId={{
                                            ruleId: nestedRowData.rule_collection_id,
                                            data: nestedRowData?.rules
                                          }}
                                        />
                                        <IconButton
                                          size="small"
                                          title="Delete"
                                          onClick={(e) => {
                                            // setDeleteId(nestedRowData.id);
                                            handleRuleDelete(e, nestedRowData.rule_collection_id);
                                          }}
                                        >
                                          <Icon icon={deleteIcon} />
                                        </IconButton>
                                      </>
                                    )}
                                  </TableCell>
                                </TableRow>
                              </>
                            );
                          })}
                        </>
                      ))}
                    </TableBody>
                  </>
                ) : (
                  <TableRow
                  // style={{
                  //   height: (dense ? 33 : 53) * emptyRows
                  // }}
                  >
                    <TableCell colSpan={collapsableTableHead.length + 1} align="center">
                      <Typography gutterBottom align="center" variant="subtitle1">
                        No Data Found
                      </Typography>
                    </TableCell>
                    {/* {open && (
                      <TableCell align="right"> */}
                    {/* <CampaignRuleDialog
                          dialogTitle="Add Campaign Rule"
                          ComponentCalled={CampaignRuleForm}
                          icon={addRule}
                          showbtnIcon
                          parentRuleId={row.id}
                        /> */}
                    {/* </TableCell>
                    )} */}
                  </TableRow>
                )}
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

CollapsableTableCampaignRule.propTypes = {
  tableHead: PropTypes.array,
  collapsableTableHead: PropTypes.array
};

export default function CollapsableTableCampaignRule({ tableHead, collapsableTableHead }) {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { campaignRulesSetData, error, isError, success, isSuccess } = useSelector((state) => state.campaignrules);
  // console.log('campaignRulesSetData', campaignRulesSetData);
  useEffect(() => {
    if (isSuccess && success) {
      enqueueSnackbar(success, {
        variant: 'success'
      });
      dispatch(getCampaignRuleData());
      dispatch(resetSuccess());
    } else if (isError && error) {
      enqueueSnackbar(error, {
        variant: 'error'
      });
      dispatch(resetError());
    }
  }, [isError, isSuccess, dispatch]);

  return (
    <Scrollbar>
      <TableContainer sx={{ minWidth: 800, mt: 3 }}>
        <Table>
          {/* Main Table Head */}
          <TableHead>
            <TableRow sx={{ backgroundColor: '#5A5A5A' }}>
              <TableCell />
              {tableHead.map((headCell) => (
                <TableCell key={headCell.id} align={headCell.align ? headCell.align : 'center'}>
                  {headCell.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {campaignRulesSetData && campaignRulesSetData.length > 0 ? (
              campaignRulesSetData?.map((row) => (
                <CollapsableTableRow key={row.id} row={row} collapsableTableHead={collapsableTableHead} />
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={tableHead.length + 1} align="center">
                  <Typography gutterBottom align="center" variant="subtitle1">
                    No Data Found
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Scrollbar>
  );
}
